/**
 * Created by caoyu on 2022/6/16.
 */
import Vue from 'vue'


Vue.prototype.disabledPermi = function (value){
  let user = JSON.parse(sessionStorage.getItem('user'));
  const permissions = user.menus;
  if (value && value instanceof Array && value.length > 0) {
    const permissionFlag = value;

    const hasPermissions = permissions.some(permission => {
      return permissionFlag.includes(permission.menu_code)
    });

    return !hasPermissions;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/common/permission/disabledPermi.js